import React, { Component } from 'react';
import main_logo from '../../static/main_logo.PNG';
import { Link } from 'react-router-dom';
import SignOutButton from './SignOutButton';
import config from '../../config/config';

export class Navbar extends Component {
  static defaultProps = {
    title: 'TX GLO Outreach'
  };
  render() {
    return (
      <div>
        <nav className='navbar bg-primary'>
          <div>
            <img
              style={{ width: '150px' }}
              src={main_logo}
              align='right'
              alt='Logo'
            />
          </div>
          <div>
            <h1 style={{ marginLeft: '110px' }}>{this.props.title}</h1>
          </div>
          <div>
            {/* <Link to="/"><button className='btn' style={{ margin: "-10px" }}>Login</button></Link> */}
            <SignOutButton />
            <Link to='/home'>
              <button className='btn' style={{ margin: '-10px' }}>
                Home
              </button>
            </Link>
            {config.decodeJWT().admin && (
              <Link to='/admin'>
                <button className='btn' style={{ margin: '-10px' }}>
                  Admin
                </button>
              </Link>
            )}
          </div>
        </nav>

        <hr style={{ background: '#54c5f1', width: '100%', height: '5px' }} />
      </div>
    );
  }
}

export default Navbar;
